import React from 'react';
import { Box, Typography, IconButton, Drawer, Divider, Collapse } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import invLogo from "../data/images/Inv-logoHorizontal.png";

const AdminHeaderComp = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [nfcOpen, setNfcOpen] = React.useState(false);
    const [invOpen, setInvOpen] = React.useState(false);
    const [posOpen, setPosOpen] = React.useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const isActiveRoute = (route) => location.pathname === route;

    const onHandleLogout = () => {
        localStorage.removeItem("invCreator");
        navigate("/login-creator");
    };

    const isNFCSiteActive = () => {
        return ['/nfc-users', '/generate-coupons'].includes(location.pathname);
    };

    const isINVPaymentsActive = () => {
        return ['/creator-client-details', '/payment-generator', '/creator-services'].includes(location.pathname);
    };

    const isPosPaymentsActive = () => {
        return ['/manage-stores'].includes(location.pathname);
    };

    React.useEffect(() => {
        // Open the relevant section based on current route
        if (isNFCSiteActive()) {
            setNfcOpen(true);
        }
        if (isINVPaymentsActive()) {
            setInvOpen(true);
        }
        if (isPosPaymentsActive()) {
            setPosOpen(true);
        }
    }, [location.pathname]);

    return (
        <Box sx={{
            width: "100%",
            height: "3.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f8f9f9",
        }}>
            <Box component="img"
                alt="INV Logo"
                src={invLogo}
                sx={{
                    width: { xs: 150, md: 200 },
                    cursor: "pointer",
                    ml: 2,
                }}
                onClick={() => navigate('/')}
            />

            <IconButton onClick={toggleDrawer(true)} sx={{ mr: 2 }}>
                <MenuIcon />
            </IconButton>

            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box
                    role="presentation"
                    sx={{
                        width: "250px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "20px",
                        mt: 2,
                        px: 3
                    }}
                >
                    <IconButton onClick={toggleDrawer(false)} sx={{ alignSelf: "flex-start" }}>
                        <ArrowForwardIosIcon color="info" />
                    </IconButton>
                    <Box width="100%"><Divider /></Box>

                    <Typography
                        sx={{
                            fontWeight: 500,
                            cursor: "pointer",
                            color: isActiveRoute("/creator-portal") ? "#2196f3" : "#566573",
                            "&:hover": { color: "#2196f3" }
                        }}
                        onClick={() => navigate("/creator-portal")}
                    >
                        Dashboard
                    </Typography>

                    <Box sx={{ width: '100%' }}>
                        <Box
                            onClick={() => setNfcOpen(!nfcOpen)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                width: '100%',
                                color: isNFCSiteActive() ? "#2196f3" : "#566573",
                                "&:hover": { color: "#2196f3" }
                            }}
                        >
                            <Typography sx={{ fontWeight: 500 }}>
                                NFC Site
                            </Typography>
                            {nfcOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </Box>
                        <Collapse in={nfcOpen} timeout="auto" unmountOnExit>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        color: isActiveRoute("/nfc-users") ? "#2196f3" : "#566573",
                                        pl: 2,
                                        "&:hover": { color: "#2196f3" }
                                    }}
                                    onClick={() => navigate("/nfc-users")}
                                >
                                    NFC Users
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        color: isActiveRoute("/generate-coupons") ? "#2196f3" : "#566573",
                                        pl: 2,
                                        "&:hover": { color: "#2196f3" }
                                    }}
                                    onClick={() => navigate("/generate-coupons")}
                                >
                                    Generate Couponcodes
                                </Typography>
                            </Box>
                        </Collapse>
                    </Box>

                    <Box sx={{ width: '100%' }}>
                        <Box
                            onClick={() => setInvOpen(!invOpen)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                width: '100%',
                                color: isINVPaymentsActive() ? "#2196f3" : "#566573",
                                "&:hover": { color: "#2196f3" }
                            }}
                        >
                            <Typography sx={{ fontWeight: 500 }}>
                                INV Payments
                            </Typography>
                            {invOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </Box>
                        <Collapse in={invOpen} timeout="auto" unmountOnExit>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        color: isActiveRoute("/creator-client-details") ? "#2196f3" : "#566573",
                                        pl: 2,
                                        "&:hover": { color: "#2196f3" }
                                    }}
                                    onClick={() => navigate("/creator-client-details")}
                                >
                                    Client Details
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        color: isActiveRoute("/payment-generator") ? "#2196f3" : "#566573",
                                        pl: 2,
                                        "&:hover": { color: "#2196f3" }
                                    }}
                                    onClick={() => navigate("/payment-generator")}
                                >
                                    Generate Payment
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        color: isActiveRoute("/creator-services") ? "#2196f3" : "#566573",
                                        pl: 2,
                                        "&:hover": { color: "#2196f3" }
                                    }}
                                    onClick={() => navigate("/creator-services")}
                                >
                                    Services
                                </Typography>
                            </Box>
                        </Collapse>
                    </Box>


                    <Box sx={{ width: '100%' }}>
                        <Box
                            onClick={() => setPosOpen(!posOpen)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                width: '100%',
                                color: isPosPaymentsActive() ? "#2196f3" : "#566573",
                                "&:hover": { color: "#2196f3" }
                            }}
                        >
                            <Typography sx={{ fontWeight: 500 }}>
                                INV POS
                            </Typography>
                            {posOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </Box>
                        <Collapse in={posOpen} timeout="auto" unmountOnExit>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        color: isActiveRoute("/manage-stores") ? "#2196f3" : "#566573",
                                        pl: 2,
                                        "&:hover": { color: "#2196f3" }
                                    }}
                                    onClick={() => navigate("/manage-stores")}
                                >
                                    Manage Stores
                                </Typography>
                            </Box>
                        </Collapse>
                    </Box>


                    <Typography
                        sx={{
                            fontWeight: 500,
                            cursor: "pointer",
                            color: isActiveRoute("/create-qr") ? "#2196f3" : "#566573",
                            "&:hover": { color: "#2196f3" }
                        }}
                        onClick={() => navigate("/create-qr")}
                    >
                        Create QR
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 500,
                            cursor: "pointer",
                            color: "#566573",
                            "&:hover": { color: "#2196f3" }
                        }}
                        onClick={onHandleLogout}
                    >
                        Logout
                    </Typography>
                </Box>
            </Drawer>
        </Box>
    );
};

export default AdminHeaderComp;
